import { baseThemeValues } from 'constants/common';

const baseProps = {
  borderRadius: '5px',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
  fontWeight: 400,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

const labelPlaceholderLgBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
  fontWeight: 400,
};

const labelBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
};

// ==================================================

const baseSmProps = {
  borderRadius: '5px',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

const labelPlaceholderSmBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 400,
};

const labelSmBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

const inputButton = {
  base: {
    bg: 'palette.transparent',
    icon: 'palette.tertiary.40',
  },
  hover: {
    bg: 'palette.tertiary.60:0.1',
    icon: 'palette.tertiary.50',
  },
  pressed: {
    bg: 'palette.tertiary.40:0.2',
    icon: 'palette.tertiary.60',
  },
};

export const inputTheme = {
  lg: {
    baseProps,
    button: inputButton,
    disabled: {
      ...baseProps,
      bg: 'palette.neutral.5',
      borderColor: 'palette.neutral.5',
      endIcon: 'palette.neutral.40',
      label: {
        ...labelBase,
        text: 'palette.neutral.40',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.neutral.40',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.neutral.40',
      },
      startIcon: 'palette.neutral.40',
      text: 'palette.neutral.40',
    },
    error: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.error.60',
      endIcon: 'palette.tertiary.40',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelBase,
        text: 'palette.error.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.error.60',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.error.60',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    focus: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      borderWidth: '1px',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        fontSize: '12px',
        text: 'palette.tertiary.60',
      },
      outlineColor: 'palette.tertiary.50',
      outlineWidth: '1px',
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.transparent',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    hover: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.60',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.60',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    inactive: {
      ...baseProps,
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      endIcon: 'palette.tertiary.40',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.50',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.50',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    labelBase,
    labelPlaceholderBase: labelPlaceholderLgBase,
    placeholderBase: labelBase,
  },
  md: {
    baseProps,
    button: inputButton,
    disabled: {
      ...baseProps,
      bg: 'palette.neutral.5',
      borderColor: 'palette.neutral.5',
      endIcon: 'palette.neutral.40',
      label: {
        ...labelBase,
        text: 'palette.neutral.40',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.neutral.40',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.neutral.40',
      },
      startIcon: 'palette.neutral.40',
      text: 'palette.neutral.40',
    },
    error: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.error.60',
      endIcon: 'palette.tertiary.40',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelBase,
        text: 'palette.error.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.error.60',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.error.60',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    focus: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      borderWidth: '1px',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        fontSize: '12px',
        text: 'palette.tertiary.60',
      },
      outlineColor: 'palette.tertiary.50',
      outlineWidth: '1px',
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.transparent',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    hover: {
      ...baseProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.60',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.60',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    inactive: {
      ...baseProps,
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      endIcon: 'palette.tertiary.40',
      label: {
        ...labelBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.50',
      },
      placeholder: {
        ...labelPlaceholderLgBase,
        text: 'palette.tertiary.50',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    labelBase,
    labelPlaceholderBase: labelPlaceholderLgBase,
    placeholderBase: labelBase,
  },
  sm: {
    baseSmProps,
    button: inputButton,
    disabled: {
      ...baseSmProps,
      bg: 'palette.neutral.5',
      borderColor: 'palette.neutral.5',
      endIcon: 'palette.neutral.40',
      label: {
        ...labelSmBase,
        text: 'palette.neutral.40',
      },
      labelPlaceholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.neutral.40',
      },
      placeholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.neutral.40',
      },
      startIcon: 'palette.neutral.40',
      text: 'palette.neutral.40',
    },
    error: {
      ...baseSmProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.error.60',
      endIcon: 'palette.tertiary.40',
      helpText: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '12px',
        fontWeight: 400,
        text: 'palette.error.60',
      },
      label: {
        ...labelSmBase,
        text: 'palette.error.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.error.60',
      },
      placeholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.error.60',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    focus: {
      ...baseSmProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      borderWidth: '1px',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderSmBase,
        fontSize: '12px',
        text: 'palette.tertiary.60',
      },
      outlineColor: 'palette.tertiary.50',
      outlineWidth: '1px',
      placeholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.transparent',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    hover: {
      ...baseSmProps,
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.50',
      endIcon: 'palette.tertiary.50',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.tertiary.60',
      },
      placeholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.tertiary.60',
      },
      startIcon: 'palette.tertiary.50',
      text: 'palette.tertiary.95',
    },
    inactive: {
      ...baseSmProps,
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.20',
      endIcon: 'palette.tertiary.40',
      label: {
        ...labelSmBase,
        text: 'palette.tertiary.60',
      },
      labelPlaceholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.tertiary.50',
      },
      placeholder: {
        ...labelPlaceholderSmBase,
        text: 'palette.tertiary.50',
      },
      startIcon: 'palette.tertiary.40',
      text: 'palette.tertiary.95',
    },
    labelPlaceholderSmBase,
    placeholderBase: labelSmBase,
  },
};
